import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { Typography } from "@mui/material";
import EscoDataGrid from "../../Controls/EscoGrid/EscoDataGrid";
import { getFrmParamsLista } from "../../../Service/frmParametros";
import FrmParamsView from "./FrmParamsView";

export default function FrmParamsDataView() {


    const [frmParams, setFrmParams] = useState([]);
    const [loading, setLoading] = useState(false);
    const { accessToken } = useContext(AuthContext);
    const { tokenExpiration, getAccessToken } = useContext(AuthContext);
    const [rowSelectd, setRowSelectd] = useState("Hola");


    //region - "description"

    /*DELETE INICIO*/
    //const [showDelete, setShowDelete] = useState(false)

    /*     const closeDeleteDialog = () => {
            setShowDelete(false);
        };   
    
        const ConfirmDelete = () => {            
            delFondoImg(rowSelectd);
            setShowDelete(false);
        } */

    /* const delFondoImg = (row) => {

        var frmDelLeyendasImgOcRequest = {
            CodLeyendaImg: row.CodLeyendaImg
        }

        const datos = { frmDelLeyendasImgOcRequest }

        frmDelLeyendasImgOc(datos, accessToken)
            .then(data => {

                if(data!= undefined && data.Message != undefined && data.Message.includes("Error")){
                   
                    init();
                    return;
                }else{
                    init();
                }  
            }).catch(
                error => { 
                    
                }); 

    } */

    //endregion

    const init = () => {
        getAccessToken()
            .then((token) => {
                setLoading(true);
                getFrmParamsLista(token)
                    .then((data) => {
                        setFrmParams(data);
                        setLoading(false)
                    })
                    .catch()
                    .finally(() => setLoading(false))

            })
    }

    useEffect(() => {
        init();
    }, [])

    const columns = [
        { field: 'Descripcion', headerName: 'Descripción', width: 200 },
        { field: 'Valor', headerName: 'Valor', width: 200 },
    ];

    const rows = frmParams;

    function getRowId(row) {
        return row.CodFrmConfig
    }

    function setData(data) {
        setFrmParams(frmParams.concat({
            CodFrmConfig: data.CodFrmConfig,
            Descripcion: data.Descripcion,
            Valor: data.Valor
        }))
    }

    return (
        <div style={{ height: 600, width: '100%' }}>
            <Typography variant="button" sx={{ fontSize: 14, color: 'gray' }}>Configuración de Formularios: Parámetros </Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pEliminar={false}
                pEditar={true}
                pAgregar={false}
                //pSetShowDelete={setShowDelete}
                pSetRowSelectd={setRowSelectd}
            >
                <FrmParamsView setData={setData} pInit={init} />
            </EscoDataGrid>

        </div>
    );

};